import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  onAjaxSuccessSubmit(event) {
    const eventData = event.detail

    if (eventData.formData) {
      event.currentTarget.action = eventData.formData.action

      const methodInput = document.createElement("input")
      methodInput.setAttribute('type', 'hidden')
      methodInput.setAttribute('name', '_method')
      methodInput.value = eventData.formData.method
      event.currentTarget.append(methodInput)
    }
  }
}
